// Leitura do texto que o diário publica: separa o cabeçalho do tribunal
// (endereço, telefone, classe, partes) do ato em si (despacho, decisão…).
// O DJEN costuma mandar tudo numa linha só, por isso a busca é pela palavra
// que abre o ato, não por quebra de linha.

const ATOS = [
  ['ATO ORDINATÓRIO', 'Ato ordinatório'], ['ATO ORDINATORIO', 'Ato ordinatório'],
  ['DESPACHO', 'Despacho'], ['DECISÃO', 'Decisão'], ['DECISAO', 'Decisão'],
  ['SENTENÇA', 'Sentença'], ['SENTENCA', 'Sentença'], ['ACÓRDÃO', 'Acórdão'], ['ACORDAO', 'Acórdão'],
  ['EDITAL', 'Edital'], ['CERTIDÃO', 'Certidão'], ['CERTIDAO', 'Certidão'], ['INTIMAÇÃO', 'Intimação'], ['INTIMACAO', 'Intimação'],
  ['EMENTA', 'Acórdão'], ['PAUTA DE JULGAMENTO', 'Pauta'], ['LISTA DE DISTRIBUIÇÃO', 'Distribuição'],
]
const CABECALHO = /PODER JUDICI|TRIBUNAL|F[OÓ]RUM|CEP|TELEFONE|E-?MAIL|PROCESSO\s*:|CLASSE\s*:|ASSUNTO\s*:|POLO|COMARCA|VARA|GABINETE|SECRETARIA/i

// "S E N T E N Ç A" → "SENTENÇA" (alguns tribunais espaçam o nome do ato)
export const juntarLetrasEspacadas = (t) => String(t || '')
  .replace(/(?<![A-Za-zÀ-ÿ])((?:[A-ZÀ-Ý] ){4,}[A-ZÀ-Ý])(?![A-Za-zÀ-ÿ])/g, (m) => m.replace(/ /g, ''))

// Regras CSS que sobram quando o tribunal manda o HTML inteiro ("body{ padding: 10px; ... }")
const SELETOR_CSS = String.raw`(?:html|body|table|thead|tbody|tr|td|th|p|div|span|a|ul|ol|li|h[1-6]|#[\w-]+|\.[\w-]+)`
const CSS_SOLTO = new RegExp(String.raw`(^|[\s;}.])${SELETOR_CSS}(?:\s*,\s*${SELETOR_CSS})*\s*\{\s*[\w-]+\s*:[^{}]*\}\s*;?`, 'gi')
export function limparCssSolto(texto) {
  const original = String(texto || '')
  if (!original.includes('{')) return original
  let limpo = original
  let antes
  do {
    antes = limpo
    limpo = limpo.replace(CSS_SOLTO, '$1')
  } while (limpo !== antes)
  return limpo === original ? original : limpo.replace(/^[\s;.]+/, '').replace(/[ \t]{2,}/g, ' ').trim()
}

const limpar = (t) => juntarLetrasEspacadas(limparCssSolto(String(t || '').replace(/<(style|script|head)\b[^>]*>[\s\S]*?<\/\1>/gi, '')).replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/[ \t]+/g, ' ')).trim()

export function separarAto(texto) {
  const t = limpar(texto)
  // o ato vem depois das partes ("POLO PASSIVO: FULANO … SENTENÇA Vistos"):
  // antes disso, "SENTENÇA" costuma ser o nome da classe ("Cumprimento de Sentença (156)")
  let desde = 0
  const rotulos = /\b(POLO\s+(?:ATIVO|PASSIVO)|REQUERENTES?|REQUERIDOS?|EXEQUENTES?|EXECUTADOS?|RECLAMANTES?|RECLAMADOS?|APELANTES?|APELADOS?|AUTORE?S?|R[EÉ]US?)\s*:/g
  let r
  while ((r = rotulos.exec(t.slice(0, 2500)))) desde = r.index + r[0].length
  const procurar = (inicio) => {
    let achado = null
    for (const [chave, rotulo] of ATOS) {
      const re = new RegExp(`(^|[^A-ZÀ-Ýa-zà-ÿ])(${chave})(?![A-ZÀ-Ýa-zà-ÿ])(?!\\s*\\(\\d)`, 'g')
      re.lastIndex = inicio
      const m = re.exec(t.slice(0, 2500))
      if (m && (!achado || m.index + m[1].length < achado.inicio)) achado = { inicio: m.index + m[1].length, rotulo }
    }
    return achado
  }
  const primeiro = procurar(0)
  // texto que já abre no ato ("DESPACHO Nº … Apelante: …") fica como está
  const melhor = primeiro && primeiro.inicio === 0 ? primeiro : (desde && procurar(desde)) || primeiro
  if (!melhor) return depoisDasPartes(t)
  const cabecalho = t.slice(0, melhor.inicio).trim()
  // antes do ato só vale como cabeçalho se parecer cabeçalho de tribunal
  if (cabecalho && !CABECALHO.test(cabecalho)) return { cabecalho: '', ato: melhor.rotulo, corpo: t }
  return { cabecalho, ato: melhor.rotulo, corpo: t.slice(melhor.inicio).trim() }
}

// Sem palavra de ato (ex.: TRT: "... RECORRIDO: FULANO DE TAL A Secretaria intima..."):
// o ato começa depois do nome da última parte, que vem todo em maiúsculas
const ROTULO_PARTE = /\b(RECORRENTES?|RECORRIDOS?|RECLAMANTES?|RECLAMADOS?|AUTORE?S?|R[EÉ]US?|APELANTES?|APELADOS?|AGRAVANTES?|AGRAVADOS?|EXEQUENTES?|EXECUTADOS?|REQUERENTES?|REQUERIDOS?|IMPETRANTES?|IMPETRADOS?|EMBARGANTES?|EMBARGADOS?|INTERESSADOS?)\s*:/g
function depoisDasPartes(t) {
  let ultimo = null
  let m
  ROTULO_PARTE.lastIndex = 0
  while ((m = ROTULO_PARTE.exec(t.slice(0, 2500)))) ultimo = m
  if (!ultimo || !CABECALHO.test(t.slice(0, ultimo.index))) return { cabecalho: '', ato: null, corpo: t }
  const resto = t.slice(ultimo.index + ultimo[0].length).trim().split(' ')
  let i = 0
  const maiuscula = (w) => w && w === w.toUpperCase() && /[A-ZÀ-Ý]/.test(w)
  while (i < resto.length && maiuscula(resto[i])) i += 1
  // "A Secretaria…": a letra solta já é o começo da frase
  if (i > 0 && resto[i - 1].length === 1 && resto[i] && !maiuscula(resto[i])) i -= 1
  if (i === 0 || i >= resto.length) return { cabecalho: '', ato: null, corpo: t }
  const corpo = resto.slice(i).join(' ')
  return { cabecalho: t.slice(0, t.length - corpo.length).trim(), ato: null, corpo }
}

// "ABDORAL DE SOUSA × MINISTéRIO PÚBLICO" → "Abdoral de Sousa × Ministério Público"
export function nomeLegivel(nome) {
  return String(nome || '').toLowerCase().replace(/\s+/g, ' ').trim().split(' ')
    .map((w, i) => (/^(s\.?\/?a\.?|ltda\.?|me|epp|eireli|inss|cef)$/.test(w) ? w.toUpperCase()
      : i > 0 && /^(d[aeo]s?|e|×)$/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(' ')
}

// Uma linha para a lista: o começo do ato, sem o cabeçalho
export function resumoDoAto(texto, max = 160) {
  const { corpo } = separarAto(texto)
  const s = corpo.replace(/\s+/g, ' ').trim()
  return s.length > max ? `${s.slice(0, max)}…` : s
}

export function formatarCnj(numero) {
  const d = String(numero || '').replace(/\D/g, '')
  return d.length === 20 ? `${d.slice(0, 7)}-${d.slice(7, 9)}.${d.slice(9, 13)}.${d[13]}.${d.slice(14, 16)}.${d.slice(16)}` : String(numero || '')
}

// "DJEN · TJCE · Vara Única…" → "TJCE"
export function tribunalDe(diario) {
  const partes = String(diario || '').split('·').map((x) => x.trim()).filter(Boolean)
  return partes.find((x) => /^(TJ|TRT|TRF|TRE|ST[FJM]|TST|TSE|TJM)[A-Z0-9]*$/i.test(x)) || partes[1] || partes[0] || ''
}

// Notificação de intimação: número formatado no título e o ato no lugar do
// cabeçalho do tribunal (também conserta as que já foram gravadas assim)
export function notificacaoLegivel(titulo, descricao) {
  const t = String(titulo || '').replace(/\b\d{20}\b/g, (n) => formatarCnj(n))
  // "Para maiores informações, clique no link a seguir: https://…" é só ruído no aviso
  const d = String(descricao || '').replace(/para maiores informa[çc][õo]es,?\s*clique no link a seguir:?\s*\S*/i, '').trim()
  if (!/PODER JUDICI|TRIBUNAL REGIONAL/i.test(d.slice(0, 120))) return { titulo: t, descricao: d.replace(/\b\d{20}\b/g, (n) => formatarCnj(n)) }
  const { ato, corpo } = separarAto(d)
  // gravada só com o cabeçalho (texto cortado antes do ato): o título já basta
  return { titulo: t, descricao: ato || corpo !== limpar(d) ? resumoDoAto(d, 220) : '' }
}
